/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-04-26T14:31:04.564
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getReportFinancialPaymentReminderEditInit,
	getReportFinancialPaymentReminderView
} from '@api/report/ReportFinancialPaymentReminder';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getReportFinancialPaymentReminderEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportFinancialPaymentReminderEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getReportFinancialPaymentReminderView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportFinancialPaymentReminderView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
